import { InfoFilled } from "@element-plus/icons-vue";
import { defineStore } from "pinia";

export interface WorkList {
    id: number,
    work_name: string,
    work_cover_url: string,
    work_type: number,
    work_status: number,
    work_created_time: string,
    work_introduce: string
}

export const useWorkInfoArray = defineStore('workList', {
    state: () => ({
        workArray: [] as WorkList[]
    }),
    actions: {
        updateWorkInfoArray(info: WorkList[]) {
          this.workArray = info
          console.log('修改成功啦！！', this.workArray)
          
        }
    },
    getters: {
        getWorkInfoArray(): WorkList[] {
            if(!this.workArray || this.workArray.id === 0){
                return [];
            }else {
                return this.workArray;
            }
        }
    }

})